import React from 'react';
import PropTypes from 'prop-types';
import LabelPill from '../../../shared/components/pill/LabelPill';
import { getIntegrationManifest } from '../../../integrations';

export default function IntegrationAvailableCard({ integrationType, onSetup }) {
  const manifest = getIntegrationManifest(integrationType.type);
  const displayName = integrationType.display_name || manifest?.displayName || integrationType.type;

  return (
    <div className="d-flex align-items-start gap-3 bg-white border rounded-4 p-3 shadow-sm">
      <div
        className={`d-flex align-items-center justify-content-center rounded-3 flex-shrink-0 ${manifest?.colorClass || 'bg-light'}`}
        style={{ width: 52, height: 52 }}
      >
        {manifest?.logo ? (
          <img src={manifest.logo} alt={displayName} style={{ width: 32, height: 32 }} />
        ) : (
          <i className="bi bi-puzzle-fill fs-2 text-secondary" />
        )}
      </div>
      <div className="flex-grow-1">
        <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
          <div className="fw-bold fs-5">{displayName}</div>
          {(integrationType.roles || []).map((role) => (
            <LabelPill key={role} tone="info">
              {role === 'iot_backend' ? 'IoT backend' : role}
            </LabelPill>
          ))}
        </div>
        {manifest?.asset_sync_message && (
          <div className="text-muted small mb-2">{manifest.asset_sync_message}</div>
        )}
        <button type="button" className="btn btn-sm btn-primary" onClick={onSetup}>
          Set up
        </button>
      </div>
    </div>
  );
}

IntegrationAvailableCard.propTypes = {
  integrationType: PropTypes.shape({
    type: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
    setup_fields: PropTypes.arrayOf(PropTypes.object),
    setup_schema: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onSetup: PropTypes.func.isRequired,
};
